import { useNavigate } from "react-router-dom";
import "./RefundShared.css";

const Refund3 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "What is your refund policy?",
            description: "Learn about our refund policy and how to request a refund for your purchase.",
            link: "/what-is-your-refund-policy?"
        },
        {
            title: "What payment methods do you accept?",
            description: "View all the payment methods we accept for your convenience.",
            link: "/what-payment-methods-do-you-accept?"
        },
        {
            title: "Can I upgrade or change my service plan after payment?",
            description: "Learn how to modify your service plan and any applicable terms.",
            link: "/can-i-upgrade-or-change-my-service-plan-after-payment?"
        }
    ];

    return (
        <div className="rf-container">
            <header className="rf-header">
                <div className="rf-container-1200">
                    {/* <div className="rf-header-content">
                        <button 
                            className="rf-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rf-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rf-top-bar">
                            <a href="/submitrequest" className="rf-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="rf-main-content">
                <div className="rf-container-1200">
                    <nav className="rf-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/refund">Refund and Pricing</a></li>
                            <li>Refund Processing Time</li>
                        </ol>
                    </nav>

                    <article className="rf-article">
                        <header className="rf-article-header">
                            <h1 className="rf-article-title">How long does it take to process a refund?</h1>
                            <div className="rf-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="rf-article-content">
                            <p>
                                Refunds are typically processed within 7–10 business days after the request is approved. The exact timing may vary depending on your payment method and bank.
                            </p>
                            
                            {/* <h3>Refund Processing Timeline</h3>
                            <p>Once your refund request is approved, here's what you can expect:</p>
                            
                            <div className="rf-timeline">
                                <div className="rf-timeline-item">
                                    <div className="rf-timeline-icon">
                                        <FaExchangeAlt />
                                    </div>
                                    <div className="rf-timeline-content">
                                        <h4>Refund Request Received</h4>
                                        <p>We'll review your request within 1-2 business days.</p>
                                    </div>
                                </div>
                                <div className="rf-timeline-item">
                                    <div className="rf-timeline-icon">
                                        <FaCheckCircle />
                                    </div>
                                    <div className="rf-timeline-content">
                                        <h4>Approval & Processing</h4>
                                        <p>Once approved, we initiate the refund process within 24 hours.</p>
                                    </div>
                                </div>
                                <div className="rf-timeline-item">
                                    <div className="rf-timeline-icon">
                                        <FaClock />
                                    </div>
                                    <div className="rf-timeline-content">
                                        <h4>Bank Processing</h4>
                                        <p>Your bank or payment provider processes the refund (timing varies by method).</p>
                                    </div>
                                </div>
                            </div>
                            
                            <h3>Estimated Processing Times by Payment Method</h3>
                            <div className="rf-method-timelines">
                                {refundTimelines.map((item, index) => (
                                    <div key={index} className="rf-method-timeline">
                                        <h4>{item.method}</h4>
                                        <div className="rf-time-estimate">
                                            <FaClock className="rf-time-icon" />
                                            <span>{item.time}</span>
                                        </div>
                                        <p className="rf-time-note">{item.note}</p>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="rf-note">
                                <h4>Important Notes:</h4>
                                <ul>
                                    <li>Business days are Monday through Friday, excluding public holidays</li>
                                    <li>Processing time begins after your refund is approved</li>
                                    <li>Contact us if your refund hasn't appeared after the expected time</li>
                                </ul>
                            </div> */}
                        </div>
                    </article>
                    
                    {/* <div className="rf-helpful-section">
                        <h3 className="rf-helpful-title">Was this article helpful?</h3>
                        <div className="rf-helpful-buttons">
                            <button className="rf-helpful-btn positive">
                                <FaCheckCircle /> Yes, it was helpful
                            </button>
                            <button className="rf-helpful-btn negative">
                                <FaTimesCircle /> No, I need more help
                            </button>
                        </div>
                    </div> */}
                    
                    <div className="rf-related-articles">
                        <h2 className="rf-related-title">Related Articles</h2>
                        <div className="rf-related-grid">
                            {relatedArticles.map((article, index) => (
                                <a 
                                    key={index} 
                                    href={article.link} 
                                    className="rf-related-card"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(article.link);
                                    }}
                                >
                                    <h3>{article.title}</h3>
                                    <p>{article.description}</p>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Refund3;